import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router";

import { Button } from "@design-system/Button/Button";
import { Card } from "@design-system/Card/Card";
import { Text } from "@design-system/Text/Text";

import { routes } from "@pages/routes";

export const SentryRouteErrorBoundary = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  useEffect(() => {
    if (isRouteErrorResponse(error)) {
      Sentry.captureException(
        new Error(`Route error ${error.status}: ${error.statusText}`),
      );
      return;
    }

    Sentry.captureException(error);
  }, [error]);

  return (
    <Card>
      <Card.Header>
        <Card.Header.Title>Something went wrong</Card.Header.Title>
      </Card.Header>
      <Card.Body>
        <Text size={14} color="textSecondary">
          An unexpected error occurred. Try again, or return to the dashboard.
        </Text>
      </Card.Body>
      <Card.Footer>
        <Button
          variant="outlined"
          onClick={() =>
            navigate(routes.portal.dashboard.$path(), { viewTransition: true })
          }
        >
          Take me home
        </Button>
      </Card.Footer>
    </Card>
  );
};
